import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowLeft, Smartphone, Apple } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function PWAInstall() {
  // Estado para controlar qual tutorial mostrar
  const [device, setDevice] = useState("ios");

  return (
    <div className="min-h-screen bg-[#F8FAFC] px-6 py-10 pb-20">
      {/* Botão Voltar (Estilo da sua Landing) */}
      <div className="max-w-md mx-auto mb-8">
        <Link 
          to="/profile" 
          className="inline-flex items-center gap-2 text-slate-400 font-bold hover:text-indigo-600 transition-colors text-sm"
        >
          <ArrowLeft className="w-4 h-4" /> Voltar ao Perfil
        </Link>
      </div>

      <div className="max-w-md mx-auto text-center mb-10">
        <h1 className="text-3xl font-black text-slate-900 tracking-tighter mb-2">
          Instalar <span className="text-indigo-600">App</span>
        </h1>
        <p className="text-slate-500 font-medium">
          Escolha o seu sistema para ver o passo a passo:
        </p>
      </div>

      {/* Seleção de Dispositivo (Botões estilo Tab) */}
      <div className="max-w-md mx-auto flex gap-3 mb-10">
        <button
          onClick={() => setDevice("ios")}
          className={`flex-1 flex items-center justify-center gap-2 h-14 rounded-2xl font-black transition-all ${
            device === "ios" 
            ? "bg-white text-indigo-600 shadow-xl shadow-indigo-100 border-2 border-indigo-600" 
            : "bg-slate-100 text-slate-400 border-2 border-transparent"
          }`}
        >
          <Apple className="w-5 h-5" /> iPhone
        </button>
        <button
          onClick={() => setDevice("android")}
          className={`flex-1 flex items-center justify-center gap-2 h-14 rounded-2xl font-black transition-all ${
            device === "android" 
            ? "bg-white text-indigo-600 shadow-xl shadow-indigo-100 border-2 border-indigo-600" 
            : "bg-slate-100 text-slate-400 border-2 border-transparent"
          }`}
        >
          <Smartphone className="w-5 h-5" /> Android
        </button>
      </div>

      {/* Conteúdo com Animação */}
      <div className="max-w-md mx-auto">
        <AnimatePresence mode="wait">
          <motion.div
            key={device}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
            className="rounded-[40px] overflow-hidden shadow-2xl shadow-indigo-100 border border-slate-100 bg-white"
          >
            <img 
              src={device === "ios" ? "/instrucoes-ios.png" : "/instrucoes-android.png"}
              alt={`Tutorial ${device}`} 
              className="w-full h-auto"
            />
          </motion.div>
        </AnimatePresence>

        {/* Rodapé de Suporte */}
        <div className="mt-12 text-center space-y-4">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-indigo-50 border border-indigo-100 text-indigo-600 font-bold text-xs uppercase tracking-wider">
            Dica: Não ocupa espaço no celular! ⚡
          </div>
          <p className="text-slate-500 font-medium text-sm">
            Ainda com dúvidas? <br />
            <a href="mailto:contato@apptroquinho.com.br" className="text-indigo-600 font-black underline decoration-indigo-200">
              Chama a gente no suporte! ✌️
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}